import { render, staticRenderFns } from "./Persetujuan.vue?vue&type=template&id=c1c2b924&"
import script from "./Persetujuan.vue?vue&type=script&lang=js&"
export * from "./Persetujuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports